import { HeadPortal } from 'app/components/head-portal';
import { useTheme } from 'app/shared/contexts/theme';

export const CustomFonts = (): JSX.Element | null => {
  const { theme } = useTheme();

  if (!theme?.font || Object.keys(theme.font).length === 0) {
    return null;
  }

  const renderLinks = () => theme.font && Object.entries(theme.font).map(
    ([location, fontObject]) => fontObject.url && <link rel="stylesheet" key={location} href={fontObject.url} />,
  );

  return <HeadPortal>{renderLinks()}</HeadPortal>;
};
